export {
  answerVariants,
  normalizeAnswer,
  normalizeTypedMeaningAnswer,
  normalizeTypedMeaningAnswerVariants,
} from "#answer-variants";
